import React from 'react';

export const AxiLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="400"
    height="72"
    viewBox="0 0 889.51 158.08"
  >
    <g>
      <g>
        <path
          d="M223.02,51.21h12.13l0.19,5.05c1.11-1.4,5.69-6.57,13.93-6.57c13.32,0,20.59,8.23,20.59,22.58v33.45h-12.58
			V72.68c0-7.39-4.51-11.62-10.84-11.62c-6.29,0-10.82,4.24-10.82,11.62v33.04h-12.58V51.21z M116.81,105.72h-12.6V26.49h12.6
			V105.72z M143.72,105.72h-12.6V51.21h12.6V105.72z M77.46,51.21h12.46v54.51H77.46l-0.19-5.71c-2.29,2.34-8.38,7.25-16.89,7.25
			c-14.85,0-25.87-11.96-25.87-28.79c0-17.81,11.92-28.78,25.87-28.78c9.77,0,15.26,5.3,16.89,7.26L77.46,51.21z M47.38,78.47
			c0,10.46,6.41,17.43,15.32,17.43c8.08,0,15.35-5.89,15.35-17.43c0-11.21-6.96-17.43-15.35-17.43
			C53.43,61.04,47.38,68.44,47.38,78.47 M196.83,78.47c0-11.37-7.17-17.43-15.31-17.43c-9.75,0-15.36,7.92-15.36,17.43
			c0,10.03,6.05,17.43,15.35,17.43C190.06,95.9,196.83,89.53,196.83,78.47 M208.7,100.33c0,23.38-13.68,31.15-29.8,31.15
			c-10.74,0-17.22-3.24-19.5-4.32l3.13-10.83c1.42,0.74,7.31,4.24,16.27,4.24c9.38,0,17.33-6.01,17.33-16.83v-3.77
			c-1.02,1.07-6.34,7.29-17.03,7.29c-14.68,0-25.78-11.81-25.78-28.79c0-16.27,10.44-28.78,25.82-28.78
			c10.49,0,15.81,5.95,16.91,7.26l0.16-5.74h12.48V100.33z"
          fill="#3D3935"
        />
        <g>
          <g>
            <path
              d="M271.6,51.21h7.04v1.39h-2.72v7.29h-1.62V52.6h-2.71V51.21z"
              fill="#3D3935"
            />
          </g>
          <g>
            <path
              d="M279.8,51.21h2.13l1.42,4.13c0.34,1.01,0.76,2.92,0.76,2.92h0.03c0,0,0.42-1.89,0.75-2.92l1.4-4.13h2.18
					v8.68h-1.5v-4.52c0-0.94,0.1-2.71,0.1-2.71h-0.02c0,0-0.36,1.6-0.64,2.46l-1.64,4.77h-1.31l-1.65-4.77
					c-0.28-0.86-0.64-2.46-0.64-2.46h-0.02c0,0,0.1,1.76,0.1,2.71v4.52h-1.45V51.21z"
              fill="#3D3935"
            />
          </g>
        </g>
      </g>
      <path
        d="M137.41,25.18c-4.36,0-7.88,3.54-7.88,7.9c0,4.34,3.52,7.89,7.88,7.89c4.35,0,7.9-3.55,7.9-7.89
		C145.31,28.72,141.76,25.18,137.41,25.18"
        fill="#009ACE"
      />
      <g>
        <g>
          <path
            d="M332.62,77.01l-18.2-25.66H322l14.2,20.93h0.21l14.2-20.93h7.36L340.3,76.48l20.83,29.24h-7.68l-16.93-24.51
				h-0.21l-16.72,24.51h-7.36L332.62,77.01z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path d="M357.92,73.33h26.93v5.89h-26.93V73.33z" fill="#009ACE" />
        </g>
        <g>
          <path
            d="M394.99,51.34h6.52v10.1h0.21c3.37-6.31,9.05-10.52,16.62-10.52c0.84,0,1.37,0.11,1.79,0.21v6.42
				c-3.89-0.63-8.2,0.21-11.57,2.63c-4.21,3.16-7.05,8.2-7.05,14.62v30.92h-6.52V51.34z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M421.71,91.84c0-12.94,10.1-15.57,22.4-17.04c10.73-1.26,14.62-1.89,14.62-7.36v-1.05
				c0-7.36-4.63-10.94-13.04-10.94c-9.68,0-14.73,4-15.25,12.1h-6.42c0.74-10.52,7.68-17.35,21.67-17.35
				c11.89,0,19.25,4.94,19.25,16.83v29.56c0,3.26,1.26,4.63,3.58,4.73c0.74,0,1.47-0.21,2.42-0.42h0.32v4.73
				c-0.95,0.42-2.31,0.84-4.42,0.84c-4.73,0-7.68-2.42-7.99-7.68v-1.16h-0.32c-3.05,4.31-8.62,9.36-19.04,9.36
				C429.39,106.98,421.71,101.94,421.71,91.84z M458.84,86.05v-9.78c-3.47,1.89-8.83,2.84-14.09,3.58
				c-9.15,1.26-16.2,2.63-16.2,11.99c0,7.57,5.68,9.89,12.1,9.89C452.53,101.73,458.84,93.52,458.84,86.05z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M475.25,122.87v-5.78h0.32c0.95,0.32,2.42,0.74,4.94,0.74c4.1,0,7.05-1.79,9.05-7.36l1.79-4.84l-20.93-54.27
				h6.94l13.04,35.13c1.89,5.05,4.31,12.41,4.31,12.41h0.21c0,0,2.31-7.36,4.1-12.41l12.52-35.13h6.73l-22.4,60.06
				c-3.68,9.78-7.99,12.31-15.04,12.31C478.4,123.71,476.93,123.39,475.25,122.87z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M558.02,51.34h6.52v8.31h0.21c3.68-5.47,9.57-9.47,18.2-9.47c10.1,0,17.35,6,17.35,16.93v38.6h-6.52V67.75
				c0-8.2-4.73-11.99-12.41-11.99c-9.26,0-16.83,6.52-16.83,15.46v34.5h-6.52V51.34z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M607.35,88.79h6.63c0.95,9.15,7.26,12.83,15.99,12.83c9.05,0,13.78-4.21,13.78-10.52
				c0-6-3.37-7.99-14.51-10.52c-11.04-2.52-19.88-5.15-19.88-15.67c0-9.05,7.78-14.73,18.93-14.73c12.94,0,18.93,6.52,20.19,16.09
				h-6.52c-0.74-7.05-5.57-10.73-13.67-10.73c-8.41,0-12.41,4-12.41,9.05c0,6.21,5.15,7.68,15.57,10.1
				c10.94,2.31,18.83,5.05,18.83,16.3c0,9.68-7.78,16.2-20.4,16.2C615.35,107.19,607.98,99.31,607.35,88.79z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M675.51,110.56h6.31c1.16,6.31,7.36,8.83,15.25,8.83c11.57,0,17.04-6,17.04-15.57V95.2h-0.32
				c-4,6.1-9.05,9.47-17.25,9.47c-14.3,0-23.35-11.15-23.35-27.14c0-17.67,10.73-27.35,23.35-27.35c8.41,0,13.67,3.68,17.25,9.57
				h0.32v-8.41h6.42v52.27c0,6.1-1.79,11.04-5.05,14.62c-4.1,4.31-10.1,6.52-18.2,6.52C683.92,124.76,676.46,118.66,675.51,110.56z
				 M714.53,77.43c0-12.83-5.68-21.77-17.56-21.77c-10.73,0-17.04,8.73-17.04,21.98c0,12.41,5.47,21.56,16.93,21.56
				C708.96,99.2,714.53,90.47,714.53,77.43z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M731.78,30.52h6.52v29.13h0.21c3.68-5.47,9.57-9.47,18.2-9.47c10.1,0,17.35,6,17.35,16.93v38.6h-6.52V67.75
				c0-8.2-4.73-11.99-12.41-11.99c-9.26,0-16.83,6.52-16.83,15.46v34.5h-6.52V30.52z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M788.05,96.36V56.71h-8.2v-5.36h8.2V34.62h6.52v16.72h10.1v5.36h-10.1v38.6c0,3.89,1.79,5.15,5.26,5.15
				c1.47,0,3.37-0.42,4.31-0.84h0.32v5.57c-1.79,0.63-3.68,0.95-6,0.95C792.26,106.14,788.05,103.3,788.05,96.36z"
            fill="#009ACE"
          />
        </g>
        <g>
          <path
            d="M809.2,88.79h6.63c0.95,9.15,7.26,12.83,15.99,12.83c9.05,0,13.78-4.21,13.78-10.52
				c0-6-3.37-7.99-14.51-10.52c-11.04-2.52-19.88-5.15-19.88-15.67c0-9.05,7.78-14.73,18.93-14.73c12.94,0,18.93,6.52,20.19,16.09
				h-6.52c-0.74-7.05-5.57-10.73-13.67-10.73c-8.41,0-12.41,4-12.41,9.05c0,6.21,5.15,7.68,15.57,10.1
				c10.94,2.31,18.83,5.05,18.83,16.3c0,9.68-7.78,16.2-20.4,16.2C817.19,107.19,809.83,99.31,809.2,88.79z"
            fill="#009ACE"
          />
        </g>
      </g>
    </g>
    <g>
      <path d="M658.56,51.43h6.5v54.22h-6.5V51.43z" fill="#009ACE" />
    </g>
    <g>
      <g>
        <g>
          <g>
            <path
              d="M661.81,42.19c-2.08,0-3.77-1.69-3.77-3.77s1.69-3.77,3.77-3.77c2.08,0,3.77,1.69,3.77,3.77
					S663.89,42.19,661.81,42.19z"
              fill="#009ACE"
            />
          </g>
        </g>
      </g>
    </g>
    <g>
      <path d="M540.36,51.43h6.5v54.22h-6.5V51.43z" fill="#009ACE" />
    </g>
    <g>
      <g>
        <g>
          <g>
            <path
              d="M543.61,42.19c-2.08,0-3.77-1.69-3.77-3.77s1.69-3.77,3.77-3.77s3.77,1.69,3.77,3.77
					S545.69,42.19,543.61,42.19z"
              fill="#009ACE"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
